import { Component } from '@angular/core';

@Component({
  selector: 'app-orders-list-skeleton',
  templateUrl: './orders-list-skeleton.component.html',
  styleUrls: ['./orders-list-skeleton.component.scss']
})
export class OrdersListSkeletonComponent {}
